/* eslint-disable @typescript-eslint/no-explicit-any */
import Select from 'react-select';
import countryList from 'react-select-country-list';
import { Typography } from '@mui/material';

const allowedCountries = ['GB', 'US'];

interface Props {
  value: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  error?: string | false;
  touched?: boolean;
}

const countryOptions = countryList()
  .getData()
  .filter(option => allowedCountries.includes(option.value));

const customStyles = {
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: '#fff',
    zIndex: 1302,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#f0f0f0' : '#fff',
    color: '#222',
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: '#fff',
    borderRadius: 8,
    borderStyle: 'solid',
    // eslint-disable-next-line no-nested-ternary
    borderColor: state.isFocused
      ? '#5B00D7 !important'
      : state.selectProps.error && state.selectProps.touched
      ? '#d32f2f'
      : '#c4c4c4',
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.selectProps.error && state.selectProps.touched ? '#d32f2f' : 'rgba(0, 0, 0, 0.87)',
    },
    borderWidth: state.isFocused ? 2 : 1,
    minHeight: 40,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '18px',
  }),
};

export function CountrySelect({ value, onChange, onBlur, error, touched }: Props) {
  return (
    <>
      <Select
        name="country"
        options={countryOptions}
        value={countryOptions.find(option => option.value === value) || null}
        onChange={option => onChange(option ? option.value : '')}
        onBlur={onBlur}
        placeholder="Select country"
        isClearable
        classNamePrefix="react-select"
        styles={customStyles}
        {...{ error, touched }}
      />
      {touched && error && (
        <Typography color="error" variant="caption" sx={{ mt: 0.5 }}>
          {error}
        </Typography>
      )}
    </>
  );
}
